//Dcr
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import validateManyFields from '../../validations';
import '../../styles/Concerns.css';
import '../../styles/Alert.css';

const Dcr = () => {
  const location = useLocation();
  // console.log("location:", location);

  const { bookId, bookTitle, ownerId, ownerName, dcrId, dcrName } = location.state;
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const authState = useSelector(state => state.authReducer);

  useEffect(() => {
    // Access the state values
    // console.log("Book ID:", bookId);
    // console.log("Book Title:", bookTitle);
    // console.log("Owner ID:", ownerId);
    // console.log("Owner Name:", ownerName);
    // console.log("Co-Reader ID:", dcrId);
    // console.log("Co-Reader Name:", dcrName);
  }, [bookId, bookTitle, ownerId, ownerName, dcrId, dcrName]);
  // [bookId, bookTitle, ownerId, ownerName, dcrId, dcrName]);

  const mode = dcrId === null ? "add" : "update";
  // const mode = dcrId ?? "add";
// console.log("Mode ",mode)
 
  const [think5whysCode, setThink5whysCode] = useState();
  const [verifiedDcrId, setVerifieddDcrId] = useState();
  const [verifiedDcrName, setVerifieddDcrName] = useState();

  const [dcr, setDcr] = useState(null);

  const [dcrIsvalidated, setDcrIsvalidated] = useState(false);
  const [thinkWhysCodeVerificationMsg, setThinkWhysCodeVerificationMsg] = useState("");

  // State
  const [formData, setFormData] = useState({
    bookId: bookId,
    bookTitle: bookTitle,
    ownerId: ownerId,
    ownerName: ownerName,
    dcrId: dcrId,
    dcrName: dcrName,
    think5whyscode: "",
    noOfReadsAllowed: 10,
    currentNoOfReads: 0,
    isAllowed: true,
    isActive: true,
    isDeleted: false,
    createdBy: ownerId,
    dateCreated: new Date().toISOString(),
    canComment: true,
    comments: null,
    remarks: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [showAlert, setShowAlert] = useState(false);

  // Effects
  useEffect(() => {
    document.title = dcrId ? "Update" : "Add";
  }, [dcrId]);

  useEffect(() => {
    if (mode === "update") {
      const config = { url: `/dcr/${dcrId}`, method: "get", headers: { Authorization: authState.token } };
      fetchData(config, { showSuccessToast: false }).then((data) => {
        setDcr(data.dcr);
        const mongoDate = new Date(data.dcr.dateCreated);
        const jsDate = new Date(data.dcr.dateCreated);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        setFormData({
          bookId: data.dcr.bookId,
          bookTitle: data.dcr.bookId,
          ownerId: data.dcr.bookId,
          ownerName: data.dcr.bookId,
          dcrId: data.dcr.bookId,
          dcrName: data.dcr.bookId,
          think5whyscode: data.dcr.bookId,
          noOfReadsAllowed: data.dcr.noOfReadsAllowed,
          currentNoOfReads: data.dcr.currentNoOfReads,
          isAllowed: data.dcr.bookId,
          isActive: data.dcr.bookId,
          isDeleted: data.dcr.bookId,
          createdBy: data.dcr.bookId,
          dateCreated: formattedDate,
          canComment: data.dcr.canComment,
          comments: data.dcr.comments,
          remarks: data.dcr.remarks,
        });
      });
    }
  }, [mode, authState, dcrId, fetchData]);


  useEffect(() => {
    if (dcrId) {
      fetchData(`/dcr/${dcrId}`, {
        headers: { Authorization: authState.token }
      }).then(data => {
        setDcr(data.dcr);
        const jsDate = new Date(data.dcr.dateCreated);
        const formattedDate = `${jsDate.getDate().toString().padStart(2, '0')}-${(jsDate.getMonth() + 1).toString().padStart(2, '0')}-${jsDate.getFullYear()}`;
        setFormData({
          ...data.dcr,
          dateCreated: formattedDate
        });
      }).catch(error => {
        console.error('Error fetching dcr:', error);
      });
    }
  }, [dcrId, authState.token, fetchData]);

  const fetchThink5WhysCodeData = () => {
    const dcrCode = formData.think5whyscode;
    // console.log(dcrCode);
    const config = {
      url: "/auth/verifyt5wcode",
      method: "post",
      data: { think5whyscode: dcrCode }
    };
    fetchData(config)
      .then(response => {
        // console.log("data from server", response);
        // console.log("data t5wcode from server", response.t5wcode ? "true" : "false");
        if (response && response.status) {
          setDcrIsvalidated(true);
          setThinkWhysCodeVerificationMsg("Co-Reader Code is Valid");

          // console.log("setFormData before response", formData);
          setFormData({
            ...formData,
            dcrId: response.t5wcode._id,
            dcrName: response.t5wcode.name
          });
          // console.log("setFormData after response", formData);

        } else {
          setDcrIsvalidated(false);
          setThinkWhysCodeVerificationMsg("Co-Reader Code not found!!");
        }
      })
      .catch(error => {
        // console.error("Error fetching Think5Whys Code:", error);
        setDcrIsvalidated(false);
        setThinkWhysCodeVerificationMsg("Co-Reader Code not found!!");
      });
  };

  useEffect(() => {
    //
  }, [authState.token, formData]);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      if (name === "isAllowed") {
        // setIsAllowed(checked);
        const checkboxValue = checked ? 1 : 0;
        setFormData({
          ...formData,
          [name]: checkboxValue
        });
      } else if (name === "canComment") {
        // setCanComment(checked);
        const checkboxValue = checked ? 1 : 0;
        setFormData({
          ...formData,
          [name]: checkboxValue
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleReset = e => {
    e.preventDefault();
    setFormData({
      bookId: dcr.bookId,
      bookTitle: dcr.bookTitle,
      ownerId: dcr.ownerId,
      ownerName: dcr.ownerName,
      dcrId: dcr.dcrId,
      dcrName: dcr.dcrName,
      think5whyscode: dcr.think5whyscode,
      noOfReadsAllowed: dcr.noOfReadsAllowed,
      currentNoOfReads: dcr.currentNoOfReads,
      isAllowed: dcr.isAllowed,
      isActive: dcr.isActive,
      isDeleted: dcr.isDeleted,
      createdBy: dcr.createdBy,
      dateCreated: dcr.dateCreated,
      canComment: dcr.canComment,
      comments: dcr.comments,
      remarks: dcr.remarks,
    });
  }

  const handleVerify = (code) => {
    if (code === "") {
      return;
    }
    fetchThink5WhysCodeData();
  };

  const handleSubmit = e => {
    e.preventDefault();
    const errors = validateManyFields("dcr", formData);
    setFormErrors({});
    if (errors.length > 0) {
      setFormErrors(errors.reduce((total, ob) => ({ ...total, [ob.field]: ob.err }), {}));
      return;
    }
    const url = dcrId ? `/dcr/${dcrId}` : "/dcr/add";
    const method = dcrId ? "put" : "post";
    // console.log("url ",url);
    // console.log("method ",method);
    // console.log("formData ",formData);
    // console.log("authState.token ",authState.token);
    fetchData(url, { method, data: formData, headers: { Authorization: authState.token } }).then(() => {
      // navigate("/dcrlist");
      navigate('/dcrlist', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, fromPage: "dcr" }});

    }).catch(error => {
      console.error('Error submitting form data:', error);
    });
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )


const handleDcrListClick = (bookId, bookTitle) => {
    // console.log(bookId, bookTitle, ownerId, ownerName);
    navigate('/dcrlist', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, fromPage: "dcr" }});
};


  return (
    <MainLayout>
      <div>
        <h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Flying On The Wall</h3>
      </div>
      <form className='m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full'>
        {loading ? (
          <Loader />
        ) : (
          <div className='text-white text-m'>
            <h2 className="border-container-gray" style={{ color: 'white', backgroundColor: 'darkblue' }}>{dcrId ? "Update" : "Add"}</h2>
            <div className="border-container-gray ml-8">
              <div className="mb-4 text-orange-400">
                <p>Input 12 character Think5Whys Code of the Person to add in "Flying On The Wall" List for Your Book - (Book Title)</p>
                <p>Think5Whys Code of the Person can be found in "My Think5Whys Code" under the "Profile" module</p>
                <label htmlFor="think5whyscode">Think5Whys Code:</label>
                <br />
                <input type="text" name="think5whyscode" id="think5whyscode" value={formData.think5whyscode} onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', width: '20%' }} />
                <button className='button-style ml-4' onClick={handleVerify}>Verify</button>
                <div className={dcrIsvalidated ? 'text-green-500' : 'text-orange-500'}>
                  {thinkWhysCodeVerificationMsg}
                </div>
              </div>
              {/* {dcrIsvalidated ? "True" : "False"} */}
              {dcrIsvalidated && (
                <>
                  <div className="mb-4">
                    <p>For the Book:  {formData.bookTitle}</p>
                    <p>Name of the Co-Reader you are going to Add is: {formData.dcrName}</p>
                  </div>
                  <div className="mb-4">
                    <label>
                      <input
                        type="checkbox"
                        checked={formData.isAllowed}
                        onChange={handleChange}
                        name="isAllowed"
                        className="mr-2"
                      />
                      Is Allowed
                    </label>
                  </div>
                  <div className="mb-4">
                    <label>
                      <input
                        type="checkbox"
                        checked={formData.canComment}
                        onChange={handleChange}
                        name="canComment"
                        className="mr-2"
                      />
                      Can Comment
                    </label>
                  </div>

                  <div className="border-container-gray">
                    <div className="mb-4">
                      <label htmlFor="remarks">Remarks:</label>
                      <br />
                      <input 
                        type="text" 
                        name="remarks" 
                        id="remarks" 
                        value={formData.remarks} 
                        onChange={handleChange} 
                        className='text-black text-m'
                        style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                      />
                      {fieldError("remarks")}
                    </div>
                  </div>
                  <div style={{ padding: '20px', display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                    <button className='button-style' onClick={handleSubmit}>{dcrId ? "Update" : "Add New"}</button>
                    {/* <button className='button-style' onClick={() => navigate("/dcrlist")}>Cancel</button> */}
                    <button className='button-style' onClick={() => handleDcrListClick(book.bookId, book.bookTitle)}>Cancel</button>
                    {dcrId && <button className='button-style' onClick={handleReset}>Reset</button>}
                  </div>
                </>
              )}
              {!dcrIsvalidated && (
                <button className='button-style' onClick={() => handleDcrListClick(book.bookId, book.bookTitle)}>Return</button>
              )}
            </div>
          </div>
        )}
      </form>
    </MainLayout>
  );
};

export default Dcr;
